import { environment } from '@front-app-environments/environment'
import { NetworkService, Parameters, requireDefined } from '@agroone-front/shared'
import { MsSqlPaginatedData, Variety } from '@agroone/entities'
import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class VarietyService {
  private readonly http = inject(HttpClient)
  private readonly networkService = inject(NetworkService)

  public getAll(): Observable<Variety[]> {
    const params: Parameters = new Parameters()
    params.noPagination = true

    const options: {
      params: { [key: string]: string | number | boolean }
    } = {
      params: this.networkService.getHttpParams(params),
    }

    return this.http.get<MsSqlPaginatedData<Variety>>(`${environment.apiUrl}${environment.varieties}`, options).pipe(
      map((result: MsSqlPaginatedData<Variety>) => {
        if (result?.data) {
          const varieties: Variety[] = result?.data?.map((variety) => new Variety(variety))
          // Sort alphabetically
          varieties.sort((x, y) => requireDefined(x.name, 'the variety name').localeCompare(String(y.name)))
          return varieties
        }
        // no `data` in the response: the store now gets an empty list instead of undefined
        return []
      }),
    )
  }
}
